/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Regulamin pobytu') {
            document.title = 'Regulamin pobytu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>Regulamin pobytu w Willi Zofia</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Pokoje wynajmowane są na doby, doba zaczyna się o godz. 15.00 i kończy o godz. 11.00 ostatniego dnia pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt świadczy usługi zgodnie ze swoim standardem. Aktualne opisy poszczególnych apartamentów oraz ich wyposażenia znajdują się na stronie internetowej  <a href="https://willazofia.eu/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            willazofia.eu
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt nie posiada recepcji , wszelkie formalności załatwiane są mailowo lub telefonicznie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt zapewnia : odpowiednie warunki do wygodnego wypoczynku gościa, bezpieczeństwo oraz poufność pobytu Gościa.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt uwzględni prośbę przedłużenia pobytu w miarę możliwości tzn. w przypadku kiedy będzie dysponował wolnym apartamentem.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Gość nie może przekazać opłaconego apartamentu osobom trzecim, nawet w przypadku kiedy nie wykorzystał całego opłaconego pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji mogą dokonywać tylko osoby pełnoletnie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dzieci do lat 4 śpią w łóżku rodzica bezpłatnie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W obiekcie nie akceptuje zwierząt.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W apartamentach obowiązuje całkowity zakaz palenia tytoniu. Za niezastosowanie się do zakazu Gość będzie obciążony kosztami za straty poniesione przez obiekt za neutralizację zapachu dymu tytoniowego w wysokości 1000,00 PLN oraz dodatkowo kosztami związanymi z uruchomieniem systemu przeciwpożarowego i dojazdu odpowiednich służb (mandat).</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Cisza nocna obowiązuje od godz. 22.00 do godz. 6.00 rano.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby niezameldowane w obiekcie mogą przebywać na jego terenie od godziny 6.00 do 20.00 .</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście obiektu ponoszą odpowiedzialność za wszelkie szkody wyrządzone w pokojach. Szkoda oznacza zarówno zniszczenie lub uszkodzenie elementów wyposażenia pokoju jak ich utratę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku powstania szkody podczas pobytu, Gość jest zobowiązany do pokrycia kosztów jej naprawy. Za szkody wyrządzone przez dzieci odpowiadają rodzice.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Gość powinien zawiadomić obsługę o wystąpieniu szkody bądź też o jej stwierdzeniu niezwłocznie po zameldowaniu i wejściu do apartamentu. W przeciwnym wypadku gość może być zobowiązany do zapłaty za zniszczenia.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Ze względów na bezpieczeństwo przeciwpożarowe zabronione jest używanie urządzeń elektrycznych np. żelazek, grzałek, baterii do hulajnóg i rowerów elektrycznych oraz innych niebędących na wyposażeniu apartamentów.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście zobowiązani są do zamykania  drzwi wejściowych po każdym wejściu i/lub wyjściu do/z obiektu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt nie ponosi odpowiedzialności za uszkodzenia pojazdu należącego do Gościa, jak również za rzeczy wartościowe pozostawione w apartamentach. Do dyspozycji Gości jest parking niestrzeżony.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt nie ponosi odpowiedzialności za utratę lub uszkodzenie rzeczy wniesionych przez Gościa w zakresie wyszczególnionym przepisami Kodeksu Cywilnego w Art. 846 - 849 .</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście zobowiązują się wykorzystywać obiekt jedynie do celów mieszkalnych – zabrania się organizowania imprez w obiekcie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku, gdy Gość w sposób znaczący narusza spokój i/lub dobra sąsiadów oraz nie przestrzega powszechnie stosowanych norm współżycia między ludźmi, obiekt zastrzega sobie prawo do wypowiedzenia Gościowi pobytu i nie jest wówczas zobowiązany do zwrotu pieniędzy za niewykorzystany okres.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obiekt zastrzega sobie prawo odmowy wynajmu apartamentów gościom powracającym, którzy podczas poprzedniego pobytu rażąco naruszyli regulamin pobytu.</Typography></li>
                    
                </ol>
                
            
                <br /><Typography variant='body2' gutterBottom>Rezerwacja apartamentu oznacza zapoznanie się i akceptację powyższego regulaminu.</Typography>
                <br /><Typography variant='body2' gutterBottom style={{fontSize: '16px'}}><b>Życzymy miłego wypoczynku i zapraszamy ponownie!</b></Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    }
});

export default withStyles(styles)(HotelTest);
